import http from "../utils/http-common";

const baseHistoryPath = "api/others-history";

export const getOptionsFilter = (query: string) => {
  return http.get(`${baseHistoryPath}/options/filter-others-logs?${query}`);
};

export const getHistory = (query: string) => {
  return http.get(`${baseHistoryPath}?${query}`);
};
